import { alpha, lighten } from '@mui/material';
import { common } from '@mui/material/colors';
import { identity } from 'fp-ts/function';
import { blue, green, neutral, purple, red, teal, yellow } from './colors';
import { ProximaNova } from './font';
export var baseTheme = {
  site: {
    maxBlockWidth: 1180,
    navbarAlignment: 'left'
  },
  shape: {
    borderRadius: 4
  },
  palette: {
    primary: {
      main: blue[500],
      dark: blue[700],
      light: blue[100],
      background: alpha(blue[700], 0.08),
      contrastText: common.white
    },
    secondary: {
      main: neutral[20],
      dark: neutral[40],
      light: neutral[10],
      background: alpha(neutral[700], 0.08),
      contrastText: neutral[700]
    },
    neutral: {
      main: neutral[500],
      dark: neutral[700],
      light: neutral[100],
      background: neutral[50],
      contrastText: common.white
    },
    accent: {
      main: purple[500],
      dark: purple[700],
      light: purple[100],
      background: alpha(purple[700], 0.08),
      contrastText: common.white
    },
    accentSecondary: {
      main: teal[700],
      dark: teal[900],
      light: teal[300],
      background: alpha(teal[700], 0.08),
      contrastText: common.white
    },
    action: {
      active: neutral[700],
      focus: neutral[20],
      hover: neutral[10],
      selected: neutral[40],
      disabledBackground: neutral[20],
      disabled: neutral[100]
    },
    divider: neutral[40],
    text: {
      primary: neutral[700],
      secondary: neutral[500],
      disabled: neutral[100]
    },
    other: {
      banner: blue[500],
      backdrop: alpha(neutral[700], 0.4),
      snackbar: neutral[700],
      activeRating: yellow[500],
      facebook: '#4267B2',
      linkedIn: '#2867B2',
      twitter: '#1DA1F2',
      coin: '#E1B530'
    },
    error: {
      main: red[500],
      dark: red[700],
      light: red[500],
      background: lighten(red[700], 0.9),
      contrastText: common.white
    },
    warning: {
      main: yellow[500],
      dark: yellow[700],
      light: yellow[500],
      background: lighten(yellow[700], 0.9),
      contrastText: common.black
    },
    info: {
      main: blue[500],
      dark: blue[700],
      light: blue[500],
      background: lighten(blue[700], 0.9),
      contrastText: common.white
    },
    success: {
      main: green[500],
      dark: green[700],
      light: green[500],
      background: lighten(green[700], 0.9),
      contrastText: common.white
    }
  },
  typography: {
    fontFamily: ProximaNova,
    allVariants: {
      fontWeight: 'normal'
    },
    h1: {
      fontSize: '34px',
      lineHeight: '123.5%'
    },
    h2: {
      fontSize: '24px',
      lineHeight: '133.4%'
    },
    h3: {
      fontSize: '20px',
      lineHeight: '160%'
    },
    h4: {
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '160%'
    },
    h5: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '157%'
    },
    h6: {
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '157%'
    },
    // body regular
    body1: {
      fontSize: '16px',
      lineHeight: '150%'
    },
    // body small
    body2: {
      fontSize: '14px',
      lineHeight: '143%'
    },
    button: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '170%',
      textTransform: 'none'
    },
    buttonLarge: {
      fontWeight: 'bold',
      fontSize: '15px',
      lineHeight: '170%'
    },
    buttonSmall: {
      fontWeight: 'bold',
      fontSize: '13px',
      lineHeight: '170%'
    },
    caption: {
      fontSize: '12px',
      lineHeight: '120%'
    },
    subscript: {
      fontSize: '10px',
      lineHeight: '120%'
    },
    overline: {
      fontSize: '12px',
      textTransform: 'uppercase',
      lineHeight: '266%',
      letterSpacing: '1px'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 768,
      lg: 1024,
      xl: 1440,
      xxl: 1920
    }
  },
  zIndex: identity({
    _0: 0,
    _1: 1,
    _2: 2,
    _3: 3,
    _100: 100,
    popover: 500,
    abovePopover: 599,
    lensBar: 1120,
    lensBarNotifications: 1110,
    stickyBlock: 600,
    aboveStickyBlock: 601,
    aboveChatPopover: 1000,
    belowDrawer: 1199,
    aboveDrawer: 1201,
    aboveModal: 1301
  }),
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: red[500]
        }
      }
    }
  }
};